import React from 'react';
import PropTypes from "prop-types";
import _maxBy from "lodash/maxBy";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, XAxis, YAxis } from "recharts";
import { selectBarChartData } from "../../../../utils";
import SRLStackedRowGraph, { FrequencyBars, FrequencyLegend, FrequencyAliases } from "../SRLStackedRowGraph/SRLStackedRowGraph";
import SRLFrequencyCustomTooltip from "../SRLStackedRowGraph/SRLFrequencyCustomTooltip/SRLFrequencyCustomTooltip";
import { getFormattedDataStackedBarChart } from "../SRLStackedRowGraph/SRLStackedRowGraphUtil";
import s from './SRLChallengeAndRecallContent.module.css';

const HEIGHT_GRAPH = 242;
const Y_AXIS_WIDTH_INTRO = 228;

const getFormattedDataBarChart = (insightsData) => (
  insightsData.map(item => ({
    ...item,
    answer: item.display_text || item.answer,
  }))
);


const getIntroGraph = (height, chartData, barKey, yAxisWidth) => {
  const fontSizeConfig = {
    fontFamily: 'Source Sans Pro',
    fontSize: 14,
    fill: '#242424',
  };

  let highDomainLimit = 40;
  const maxData = _maxBy(chartData, (item) => item && Number(item.student_count));
  if (maxData) {
    highDomainLimit = Number(maxData.student_count) + (Number(maxData.student_count) * 0.15);// how all the graphs doesn't have the same aspect here we just need to a 15% more to show values of 3 digits
  }
  const domain = [0, highDomainLimit];

  return (
    <ResponsiveContainer height={height}>
      <BarChart
        data={chartData}
        margin={{ top: 16, right: 0, bottom: 0, left: 0 }}
        barSize={13}
        layout="vertical"
      >
        <Bar
          dataKey={barKey}
          fill="var(--prs-c-info-800)"
          minPointSize={0}
          label={{
            ...fontSizeConfig,
            value: barKey,
            position: 'right',
          }}
        />

        <XAxis
          type="number"
          tick={false}
          axisLine={false}
          label={{
            ...fontSizeConfig,
            value: 'total students',
            position: 'center',
            fontStyle: 'italic',
            fill: 'var(--prs-c-gray-700)',
          }}
          domain={domain}
        />

        <YAxis
          type="category"
          dataKey="answer"
          tickLine={false}
          tickMargin={5}
          width={yAxisWidth}
          tick={fontSizeConfig}
        />
        <CartesianGrid vertical={false} horizontal={false} />
      </BarChart>
    </ResponsiveContainer>
  );
};

const getIntroContent = (insightsData, isMobileXS) => {
  const graphData = selectBarChartData(insightsData);
  const formattedData = getFormattedDataBarChart(graphData);

  return (
    <div className={`${isMobileXS ? s.fixedHeight : ''}`}>
      {getIntroGraph(HEIGHT_GRAPH, formattedData, 'student_count', Y_AXIS_WIDTH_INTRO)}
    </div>
  );
};


const getContent = (insightsData, isMobileXS) => (
  <div className={isMobileXS ? s.fixedHeight : ''}>
    <SRLStackedRowGraph
      yAxisWidth={230}
      chartData={getFormattedDataStackedBarChart(insightsData, FrequencyAliases)}
      height={HEIGHT_GRAPH}
      legendComponent={FrequencyLegend}
      bars={FrequencyBars}
      tooltipContent={SRLFrequencyCustomTooltip}
    />
  </div>
);


const SRLChallengeAndRecallContent = ({ data, isMobileXS }) => {
  const { isSRLIntroSurvey, insightsData } = data;

  return isSRLIntroSurvey ?
    getIntroContent(insightsData, isMobileXS) :
    getContent(insightsData, isMobileXS);
};

SRLChallengeAndRecallContent.propTypes = {
  data: PropTypes.shape({
    insightsData: PropTypes.array.isRequired,
    isSRLIntroSurvey: PropTypes.bool,
  }),
  isMobileXS: PropTypes.bool,
};

export default SRLChallengeAndRecallContent;
